var map = {
	"./bitmain-d9-x5.png": 512,
	"./bitmain-e9.png": 9214,
	"./bitmain-ks3.png": 6118,
	"./bitmain-l7-l9-ka3.png": 1681,
	"./bitmain-s19-air-hs3-k7.png": 2627,
	"./bitmain-s19.png": 8954,
	"./bitmain-z15.png": 5596,
	"./goldshell-kd.png": 510,
	"./iceriver-ks0.png": 1566,
	"./iceriver-ks1-ks2-ks3m.png": 2222,
	"./jasminer-x16p.png": 9658,
	"./jasminer-x4-1u.png": 3891,
	"./jasminer-x4q-x16q.png": 1084,
	"./s21-hydro.png": 509,
	"./whatsminer-m30s++.png": 6026,
	"./whatsminer-m30s+.png": 516,
	"./whatsminer-m50.png": 9169,
	"./whatsminer-m50s.png": 3218,
	"./whatsminer-m53.png": 1174,
	"./whatsminer-m56.png": 2475,
	"./whatsminer-m56s.png": 5722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8915;